export const DEPARTMENT_IMPORT_HEADER_ROW = [
  "department",
  "email",
  "first_name",
  "last_name",
  "functions",
].join(",");

export function downloadDepartmentImportTemplateCsv() {
  const blob = new Blob([`${DEPARTMENT_IMPORT_HEADER_ROW}\n`], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "departments-import-template.csv";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
